import { PERMISSIONS } from '@/core/constants/permission.constant';
import { DashboardProvider } from '../context';
import { DashboardList } from './List';
import { WithAuthorize } from '@/core/hocs/Authorize/wihAuthorize';

const IndexDashboard = () => {
  return (
    <DashboardProvider>
      <DashboardList />
    </DashboardProvider>
  );
};

export const UIndexDashboard = WithAuthorize(IndexDashboard, PERMISSIONS.DASHBOARDS.VIEW);
